import { Col, Row } from 'reactstrap';
import { Icon } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';

type SurveysNotificationProps = {
  showPendingNotification: boolean;
};

export function PendingSurveysNotification({
  showPendingNotification,
}: SurveysNotificationProps) {
  const { t } = useTranslation();

  return showPendingNotification ? (
    <Row
      style={{
        backgroundColor: '#DDEFFF',
        border: '1px solid #B7D2E6',
        borderRadius: 8,
        fontSize: '16px',
        padding: 16,
        margin: '21px 0',
        display: 'flex',
        alignItems: 'center',
      }}
      noGutters
    >
      <Col xs="auto" style={{ marginRight: 14 }}>
        {Icon({ name: 'information', size: 36 })}
      </Col>
      <Col>{t(`myCourses.surveys.pendingSurveysNotification`)}</Col>
    </Row>
  ) : (
    <></>
  );
}
